import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import useStore from '@/store/store';
import OutsideClickHandler from '@/shared/OutsideClickHandler';
import { useCommStore } from '@/components/communication/commStore';
import { useInterestStore } from '@/components/dashboard/interestStore';

// Next to «Χρονολόγιο» on Live: one bell for what's waiting — new requests
// from the website's interest form (masters only, as Επισκόπηση is theirs)
// and unread messages (anyone with the Communication Center). On a phone the
// header's numbers sit inside the closed menu, so this is where they show.
export const NotificationBell = () => {
	const [open, setOpen] = useState(false);
	const navigate = useNavigate();
	const user = useStore(s => s.user);
	const commMe = useCommStore(s => s.me);
	const openPanel = useCommStore(s => s.openPanel);
	const newInterest = useInterestStore(s => s.newCount);

	const isMaster = user?.role === 'master';
	const unread = commMe?.canUse ? commMe?.unread || 0 : 0;
	if (!isMaster && !commMe?.canUse) return null;

	const total = (isMaster ? newInterest : 0) + unread;
	const lines = [
		...(isMaster
			? [
					{
						key: 'interest',
						label: 'Νέα αιτήματα από το site',
						count: newInterest,
						go: () => navigate('/dashboard'),
					},
				]
			: []),
		...(commMe?.canUse
			? [{ key: 'messages', label: 'Μηνύματα', count: unread, go: () => openPanel() }]
			: []),
	];

	return (
		<OutsideClickHandler onOutsideClick={() => setOpen(false)}>
			<div className='relative'>
				<button
					type='button'
					onClick={() => setOpen(o => !o)}
					aria-label={`Ειδοποιήσεις${total ? `: ${total}` : ''}`}
					aria-expanded={open}
					className='relative flex cursor-pointer items-center py-[5px] text-[#0f9b9d]'
				>
					<Bell size={22} />
					{total > 0 && (
						<span className='absolute -top-0.5 -right-2.5 min-w-[18px] rounded-full bg-red-500 px-1 text-center text-[11px] leading-[18px] font-semibold text-white'>
							{total}
						</span>
					)}
				</button>
				{open && (
					<div className='absolute top-full left-0 z-50 mt-1 w-64 overflow-hidden rounded-lg border border-slate-200 bg-white shadow-lg'>
						{lines.map(l => (
							<button
								key={l.key}
								type='button'
								onClick={() => {
									setOpen(false);
									l.go();
								}}
								className='flex w-full cursor-pointer items-center justify-between gap-3 border-b border-slate-100 px-4 py-3 text-left text-[15px] last:border-0 hover:bg-slate-50'
							>
								<span>{l.label}</span>
								<span
									className={
										l.count > 0
											? 'rounded-full bg-red-500 px-2 text-[12px] font-semibold text-white'
											: 'text-[13px] text-slate-400'
									}
								>
									{l.count}
								</span>
							</button>
						))}
					</div>
				)}
			</div>
		</OutsideClickHandler>
	);
};
